<template>
  <CarouselHomeComponent />
  <CategoriesHomeComponent />
  <CarouselProductsComponent />
  <BrandsHomeComponent />
  <StrongsHomeComponent />
  <VerificationHomeComponent />
</template>

<script lang="ts" setup>
import BrandsHomeComponent from "./components/BrandsHome.component.vue";
import CarouselHomeComponent from "./components/CarouselHome.component.vue";
import CarouselProductsComponent from "./components/CarouselProducts.component.vue";
import CategoriesHomeComponent from "./components/CategoriesHome.component.vue";
import StrongsHomeComponent from "./components/StrongsHome.component.vue";
import VerificationHomeComponent from "./components/VerificationHome.component.vue";
</script>

<style lang="scss" scoped>
.home {
  display: flex;
  flex-direction: column;
  color: $blacked;
}

@media (max-width: 1300px) {
}

@media (max-width: 820px) {
}

@media (max-width: 630px) {
}

@media (max-height: 700px) {
}
</style>
